module.exports = __webpack_public_path__ + "static/adventcalendarbannermobile-1250290a0fbf7b371c6bd172a99f813c.gif";